var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWithButton',{attrs:{"name":"create-promocion","title":"Añadir promoción","button_title":"Añadir promoción"},on:{"cerrar":function($event){this.promocion = {}}}},[_c('Form',{attrs:{"promocion":_vm.promocion},on:{"terminado":function($event){return _vm.crearPromocion()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }